// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".th-td-style {\n  vertical-align: middle !important;\n}\n.th-style {\n  background: #EEEEEE !important;\n  font-weight: 700;\n  width: 100%;\n}\n.td-style {\n  width: 16.6%;\n}", ""]);
// Exports
module.exports = exports;
